var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Card from '@Components/Card';
import Button from '@Components/Button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
var MAP_ERRORS = {
    invalid_credentials: 'Usuario o contraseña incorrectos',
    invalid_email: 'Email no válido',
    invalid_password: 'Contraseña no válida',
    default: 'Error de conexión',
};
var Form = function () {
    var _a = useState(''), userName = _a[0], setUserName = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), showPassword = _c[0], setShowPassword = _c[1];
    var _d = useState(''), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState({}), validations = _e[0], setValidations = _e[1];
    var navigate = useNavigate();
    var login = useAuth().login;
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!validateInputs())
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, login(userName, password)];
                case 2:
                    _a.sent();
                    navigate('/');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error during login:', error_1);
                    setErrorMessage(MAP_ERRORS[error_1.code] || MAP_ERRORS.default);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var validateInputs = function () {
        var validations = {};
        if (!userName) {
            validations.userName = 'Introduce un nombre de usuario';
        }
        if (!password) {
            validations.password = 'Introduce una contraseña';
        }
        setValidations(validations);
        return Object.keys(validations).length === 0;
    };
    var handleClickShowPassword = function () { return setShowPassword(!showPassword); };
    var handleMouseDownPassword = function (event) { return event.preventDefault(); };
    return (_jsxs(Card, __assign({ width: "450px", height: "400px", sx: {
            borderRadius: '0 8px 8px 0',
        } }, { children: [_jsx(Typography, __assign({ component: "h1", variant: "h4", sx: { width: '100%' } }, { children: "Bienvenido" })), _jsxs(Box, __assign({ component: "form", onSubmit: handleSubmit, noValidate: true, sx: { display: 'flex', flexDirection: 'column', width: '100%', gap: 2 } }, { children: [_jsxs(FormControl, { children: [_jsx(FormLabel, __assign({ htmlFor: "userName" }, { children: "Usuario" })), _jsx(TextField, { error: !!validations.userName, helperText: validations.userName, id: "username", type: "text", name: "username", placeholder: "Introduce tu usuario", autoFocus: true, required: true, fullWidth: true, variant: "outlined", color: validations.userName ? 'error' : 'primary', value: userName, onChange: function (e) {
                                    setUserName(e.target.value);
                                    setValidations(__assign(__assign({}, validations), { userName: '' }));
                                } })] }), _jsxs(FormControl, { children: [_jsx(FormLabel, __assign({ htmlFor: "password" }, { children: "Contrase\u00F1a" })), _jsx(TextField, { error: !!validations.password, helperText: validations.password, name: "password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022", type: showPassword ? 'text' : 'password', id: "password", autoComplete: "current-password", required: true, fullWidth: true, variant: "outlined", color: validations.password ? 'error' : 'primary', value: password, onChange: function (e) {
                                    setPassword(e.target.value);
                                    setValidations(__assign(__assign({}, validations), { password: '' }));
                                }, InputProps: {
                                    endAdornment: (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ "aria-label": showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña', onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end" }, { children: showPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) })) }))),
                                } })] }), errorMessage && (_jsx(Alert, __assign({ severity: "error", sx: { marginTop: 2 } }, { children: errorMessage }))), _jsx(Button, __assign({ type: "submit", fullWidth: true, variant: "contained", onClick: validateInputs }, { children: "Iniciar sesi\u00F3n" }))] }))] })));
};
export default Form;
